import React, { useState, useContext, useEffect } from "react";
import {
  Page,
  Card,
  Form,
  FormLayout,
  TextField,
  Button,
  InlineStack,
  Box,
  Thumbnail,
  DropZone,
} from "@shopify/polaris";
import { ToastContext } from "../../global-contexts/Toast";
import { ValidateSettings } from "../../validators/Settings";

const SettingsForm = ({
  onSubmit,
  editable = true,
  initialData = {},
  handleFileUpload,
}) => {
  const [logo, setLogo] = useState(null);
  const [formData, setFormData] = useState({
    businessName: "",
    description: "",
    contactNumber: "",
    email: "",
    addressLine1: "",
    addressLine2: "",
    landmark: "",
    pincode: "",
    state: "",
    gstNumber: "",
    registrationNumber: "",
    documents: [],
    logo: "",
  });
  useEffect(() => {
    setFormData({
      businessName: initialData.businessName || "",
      // displayName: initialData.displayName || "",
      description: initialData.description || "",
      contactNumber: initialData.phoneNumber || "",
      email: initialData.primaryEmail || "",
      addressLine1: initialData.address1 || "",
      addressLine2: initialData.address2 || "",
      landmark: initialData.landmark || "",
      pincode: initialData.zip || "",
      state: initialData.state || "",
      gstNumber: initialData.gstNumber || "",
      registrationNumber: initialData.registrationNumber || "",
      documents: initialData.documents || [],
      logo: initialData.logo || "",
    });
    setLogo(initialData.logo);
  }, [initialData]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { setToast } = useContext(ToastContext);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleCoverImageDrop = (file) => {
    if (typeof file === "string") {
      setLogo(file);
    } else {
      setLogo(file[0]);
    }
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);

    let logoUrl = "";
    try {
      if (logo) {
        if (typeof logo === "string") {
          logoUrl = logo;
        } else if (logo) {
          logoUrl = await handleFileUpload(logo);
        }
      }
    } catch (e) {
      setToast({
        error: true,
        message: "Failed to upload logo",
        open: true,
      });
    }
    const payload = { ...formData };
    payload.logo = logoUrl;
    const validationErrors = ValidateSettings(payload);

    if (validationErrors) {
      setToast({
        error: true,
        message: validationErrors.error,
        open: true,
      });
      setIsSubmitting(false);
      return;
    }
    // console.
    try {
      await onSubmit(payload);
      setToast({
        error: false,
        message: "Store details saved successfully",
        open: true,
      });
    } catch (error) {
      setToast({
        error: true,
        message: "Failed to save store details",
        open: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCoverImageRemove = () => {
    setLogo(null);
  };

  const logoHint = !logo && (
    <DropZone.FileUpload
      actionHint={
        <>
          Min. image size 500px X 500px <br />
          Supported file formats: JPEG, JPG, PNG
        </>
      }
    />
  );

  return (
    <Page title="Store Details">
      <Form onSubmit={handleSubmit}>
        <Box>
          <DropZone
            labelAction={"Drop an image"}
            // overlayText=""
            // label="Logo"
            accept="image/*"
            type="image"
            onDrop={handleCoverImageDrop}
            allowMultiple={false}
            disabled={!editable}
          >
            {logoHint}
            {logo ? (
              typeof logo === "string" ? (
                <Box>
                  <Thumbnail source={logo} alt="Logo" size="large" />
                  <Button disabled={!editable} onClick={handleCoverImageRemove}>
                    Remove
                  </Button>
                </Box>
              ) : (
                <Box>
                  <Thumbnail
                    source={URL.createObjectURL(logo)}
                    alt="Cover Photo"
                    size="large"
                  />
                  <Button disabled={!editable} onClick={handleCoverImageRemove}>
                    Remove
                  </Button>
                </Box>
              )
            ) : (
              <DropZone.FileUpload />
            )}
          </DropZone>
        </Box>
        <br />
        <Card title="Store Information" sectioned>
          <FormLayout>
            <TextField
              label="Business Name"
              value={formData.businessName}
              onChange={(value) => handleInputChange("businessName", value)}
              disabled={!editable}
            />
            {/* <TextField
              label="Display Name"
              value={formData.displayName}
              onChange={(value) => handleInputChange("displayName", value)}
              disabled={!editable}
            /> */}

            <TextField
              label="Contact Number"
              value={formData.contactNumber}
              onChange={(value) => handleInputChange("contactNumber", value)}
              disabled={!editable}
            />
            <TextField
              label="Email"
              value={formData.email}
              onChange={(value) => handleInputChange("email", value)}
              disabled={true}
            />
            <TextField
              label="Address Line 1"
              value={formData.addressLine1}
              onChange={(value) => handleInputChange("addressLine1", value)}
              disabled={!editable}
            />
            <TextField
              label="Address Line 2"
              value={formData.addressLine2}
              onChange={(value) => handleInputChange("addressLine2", value)}
              disabled={!editable}
            />
            <TextField
              label="Landmark"
              value={formData.landmark}
              onChange={(value) => handleInputChange("landmark", value)}
              disabled={!editable}
            />
            <TextField
              label="Pincode"
              value={formData.pincode}
              onChange={(value) => handleInputChange("pincode", value)}
              disabled={!editable}
            />
            <TextField
              label="State"
              value={formData.state}
              onChange={(value) => handleInputChange("state", value)}
              disabled={!editable}
            />
            <TextField
              label="GST Number"
              value={formData.gstNumber}
              onChange={(value) => handleInputChange("gstNumber", value)}
              disabled={!editable}
            />
            <TextField
              label="Registration Number"
              value={formData.registrationNumber}
              onChange={(value) =>
                handleInputChange("registrationNumber", value)
              }
              disabled={!editable}
            />
            <TextField
              label="Description"
              value={formData.description}
              onChange={(value) => handleInputChange("description", value)}
              multiline={4}
              disabled={!editable}
            />
          </FormLayout>
        </Card>

        <br />
        <InlineStack align="start">
          <Button
            type="submit"
            loading={isSubmitting}
            variant="primary"
            disabled={isSubmitting || !editable}
            onClick={() => {
              handleSubmit();
            }}
          >
            Submit
          </Button>
        </InlineStack>
      </Form>
    </Page>
  );
};

export default SettingsForm;
